import { Box, type SxProps, type Theme } from '@mui/material';
import React from 'react';

export interface InputWithBadgeProps {
  children: React.ReactNode;
  badge: React.ReactNode;
  badgeSx?: Record<string, unknown>;
}

const DEFAULT_BADGE_SX: SxProps<Theme> = {
  position: 'absolute',
  top: -8,
  right: -8,
  backgroundColor: '#f5f5f5',
  border: '1px solid #e0e0e0',
  borderRadius: '12px',
  padding: '2px 8px',
  fontSize: '11px',
  fontWeight: 'bold',
  color: '#666',
  zIndex: 1,
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};

export default function InputWithBadge({
  children,
  badge,
  badgeSx,
}: InputWithBadgeProps) {
  const mergedBadgeSx: SxProps<Theme> = badgeSx
    ? ({
        ...DEFAULT_BADGE_SX,
        ...(badgeSx as SxProps<Theme>),
      } as SxProps<Theme>)
    : DEFAULT_BADGE_SX;

  return (
    <Box sx={{ position: 'relative' }}>
      {children}
      <Box sx={mergedBadgeSx}>{badge}</Box>
    </Box>
  );
}
